//import _ from 'underscore';
import _ from 'lodash';
import moment from 'moment';
import templateStr from 'text!./CCEW.html';
import 'portalConfig';
import DateUtil from 'gw-portals-util-js/DateUtil';
import PropertyCodeViewDirective from 'edge/platform/widgets/typeahead/matchContentDirectives/PropertyCode/PropertyCode';
import PropertyCodeUtil from 'edge/quoteandbind/common/util/PropertyCodeUtil';
import ViewModelUtil from 'edge/gw-portals-bop-components-angular/node_modules/gw-portals-viewmodel-js/ViewModelUtil.js';

export default (function () {
    return {
        restrict: 'A',
        template: templateStr,
        transclude: true,
        scope: {
            hideForm: '&',
            periodData: '=',
            saveCoveredEmployees: '&',
            perCapitaClasses: '=?',
            portalCoveredEmployees: '=',
            jobNumber: '=',
            locationMissing: '=',
            policyQuoted: '=',
            errorInSubmission: '='
        },
        controller: ['$scope', '$rootScope', 'RenewalService', 'ModalService', 'ViewModelService', '$state', '$filter', 'PolicyService', 'CancellationService', '$stateParams', function ($scope, $rootScope, RenewalService, ModalService, ViewModelService, $state, $filter, PolicyService, CancellationService, $stateParams) {
            $scope.portalCoveredEmployees = $rootScope.portalCoveredEmployees;
            $scope.renewalComplete = false;
            $scope.selectedEntry = -1;
            // DEF0932-GHC-Portal-In CCEW.js in the code $scope.employee = ViewModelService.create
            $scope.employee = ViewModelService.create({}, 'pc', 'edge.capabilities.policy.dto.WCCoveredEmployeeDTO_Ext');

            var lookupCodesPromise = RenewalService.getAllClassCodes($scope.jobNumber);
            PolicyService.getPerCapitaCodesByJobNumber($scope.jobNumber).then(function (datas) {
                $scope.perCapitaClasses = [];
                if (datas.length > 0) {
                    angular.forEach(datas, function (data) {
                        $scope.perCapitaClasses.push(data.classCode);
                    });
                }
            });
            /**
             * Function to search and retrieve a property class code based on user entered value.
             * @param {String} userinput - The class code
             * @returns {Array} - List of Class Codes based on matching value entered by user
             * @private
             */
            $scope.classcodeLookup = {
                getMatches: function getMatches(userinput) {
                    return lookupCodesPromise.then(function (propertyCodes) {
                        return _(propertyCodes).filter(function (code) {
                            return PropertyCodeUtil.toString(code).toLowerCase().includes((userinput || '').toLowerCase());
                        }).take(10).valueOf();
                    }).catch(function () {
                        return ModalService.showError('gw-portals-bop-components-angular.locationsAndBuildings.building.buildingCtrl.Error retrieving property class code', 'gw-portals-bop-components-angular.locationsAndBuildings.building.buildingCtrl.Please check for errors and try again');
                    });
                },
                toString: function toString(code) {
                    if (ViewModelUtil.isViewModelNode(code)) {
                        return code.value;
                    }
                    return PropertyCodeUtil.toString(code);
                },
                directive: PropertyCodeViewDirective
            };

            $scope.coveredEmployees = angular.copy($scope.periodData.constructionCreditList);
            $scope.selectedEntry = -1;
            var keepGoing = true;
            angular.forEach($scope.periodData.constructionCreditList, function (cons) {
                if (keepGoing) {
                    if (cons.totalMontanaWages == undefined || cons.totalHours == undefined) {
                        $scope.finalDataValidation = true;
                        keepGoing = false;
                    } else {
                        $scope.finalDataValidation = false;
                    }
                }
            });
            //adding new class
            /**
                              * Function called when user adds a new class.
                              * @param {none}
                              * @returns {none} -
                                                  sets isAddingNew flag to true,
                                                  creates a newEmployee element and corresponding ViewModel,
                                                  updates aspects on a newEmployeeLocation View object. sets value to null.
                              * @private
                              */
            $scope.addClass = function () {
                $scope.isAddingNew = true;
                $scope.newEmployee = {
                    basisAmount: null,
                    classCode: '',
                    description: '',
                    location: '',
                    noOfEmployees: null,
                    perCapita: null,
                    suffix: ''

                };
                $scope.employee = ViewModelService.create($scope.newEmployee, 'pc', 'edge.capabilities.policy.dto.WCCoveredEmployeeDTO_Ext');
                //setting up location options
                $scope.employeeLocationView = {
                    aspects: {
                        inputCtrlType: "typelist",
                        required: false,
                        availableValues: $scope.periodData.mSFLocations,
                        visible: true,
                        get validationMessages() {
                            return ['This is a required field'];
                        }
                    },
                    value: ''
                };
            };
            angular.forEach($scope.periodData.constructionCreditList, function (cons, index) {
                $scope.selectedType = 'exist';
                $scope.isAddingNew = false;
                $scope.isEditing = true;
                $scope.selectedEntry = index;
                //$scope.resetErrors();
                //setting up location
                $scope.employee = ViewModelService.create(cons, 'pc', 'edge.capabilities.policy.dto.WCCoveredEmployeeDTO_Ext');
                //$scope.employee.totalMontanaWages=employeesData[index].totalMontanaWages;
                $scope.employeeLocationView = {
                    aspects: {
                        inputCtrlType: "typelist",
                        required: false,
                        availableValues: $scope.periodData.mSFLocations,
                        visible: true,
                        get validationMessages() {
                            return ['This is a required field'];
                        },
                        get valid() {
                            return $scope.employee.location.value;
                        }
                    },
                    value: $scope.employee.location.value
                };
                $scope.employee.totalMontanaWages = cons.totalMontanaWages;
            });
            /**
             * Function called when user Edits an existing Class
             * @param {integer} - index of selected element
             * @param {Object} - employeesData
             * @param {String} - type
             * @returns {none} - sets isAdding flag to false,
                                 sets isEditing flag to true,
                                 sets the employeeView Model object with the selected element's passed in employeesData object,
                                 updates aspects on a newEmployeeLocation View object. sets value to $scope.employeeView.location.value
             * @private
             */
            $scope.onEdit = function (index, employeesData, type) {
                var keepGoingEdit = true;
                angular.forEach($scope.periodData.constructionCreditList, function (cons) {
                    if (keepGoingEdit) {
                        if (cons.totalMontanaWages == undefined || cons.totalHours == undefined) {
                            $scope.finalDataValidation = true;
                            keepGoingEdit = false;
                        } else {
                            $scope.finalDataValidation = false;
                        }
                    }
                });
                $scope.selectedType = type;
                $scope.isAddingNew = false;
                $scope.isEditing = true;
                $scope.selectedEntry = index;
                $scope.resetErrors();
                //setting up location
                $scope.employee = ViewModelService.create(employeesData[index], 'pc', 'edge.capabilities.policy.dto.WCCoveredEmployeeDTO_Ext');
                //$scope.employee.totalMontanaWages=employeesData[index].totalMontanaWages;
                $scope.employeeLocationView = {
                    aspects: {
                        inputCtrlType: "typelist",
                        required: false,
                        availableValues: $scope.periodData.mSFLocations,
                        visible: true,
                        get validationMessages() {
                            return ['This is a required field'];
                        },
                        get valid() {
                            return $scope.employee.location.value;
                        }
                    },
                    value: $scope.employee.location.value
                };
                $scope.employee.totalMontanaWages = employeesData[index].totalMontanaWages;
            }; // End of onEdit

            /**
             * Function called to reset status flags for all Errors objects  - errors, and employee Errors -
             *                                                                 location, classCode, moreSuffix, totalMontanaWages, basis, perCapita
             * @param {none}
             * @returns {none} - updates scope object with errors and employee errors.
             * @private
             */
            $scope.resetErrors = function () {
                $scope.errors = false;
                $scope.employeeErrors = {
                    location: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Location is required.') },
                    classCode: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Class Code is required.') },
                    moreSuffix: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Class Code contains more than one suffix. Please select the appropriate Class Code and Suffix.') },
                    totalMontanaWages: { status: false, message: $filter('translate')('This is a required field') },
                    totalHours: { status: false, message: $filter('translate')('This is a required field') },
                    basis: { status: false, message: $filter('translate')('Please use Estimated Wages for this class code within the range of 0 to 2147483647 without decimal.') },
                    perCapita: { status: false, message: $filter('translate')('Please use  only Per Capita for this class code within the range of 0 to 2147483647 without decimal.') }
                };
            }; // end reset errors
            /**
                * Function to set currency to usd
                * @param {String} val
                * @returns {Object} - set amount and currency values for the Vm object
                * @private
                */
            $scope.toCurrency = function (val) {
                return { amount: val, currency: 'usd' };
            };

            //setting cursor at the starting
            //service to check risk id availability
            /**
                * Function to keep track of changing class code values.
                * @param {String} val
                * @returns {Object} - sets the moreSuffix value for the scope object for the newly entered class code.
                * @private
                */
            $scope.$watch('employeeView.value.classCode', function (newVal) {
                var classCode = document.getElementById('gwClassCode');
                if (classCode != null && classCode.querySelector("textarea").value.length > 10) {
                    var input = classCode.querySelector("textarea");
                    //for IE
                    if (input.createTextRange) {
                        var part = input.createTextRange();
                        part.moveEnd("character", 0);
                        part.moveStart("character", 0);
                        part.select();
                    } else if (input.setSelectionRange) {
                        input.setSelectionRange(0, 0);
                    }
                }
                //udpate suffix error
                if (newVal != null && newVal != undefined) {
                    if (newVal.mSFClassIndicator == '00') {
                        RenewalService.getClassCodeBycode(newVal.code, $scope.jobNumber).then(function (data) {
                            if (data.length > 1) {
                                $scope.moreSuffix = true;
                            } else $scope.moreSuffix = false;
                        });
                    } else $scope.moreSuffix = false;
                } else $scope.moreSuffix = false;
            }); // End watch

            //update employee errors
            /**
              * Function to update employee errors, ensure totalMontanaWages validity, class codes with suffixes, and validate total employee hours etc.
              * @param {none} val
              * @returns {none} - sets the message based on validation error type
              * @private
              */
            $scope.updateEmployeeErrors = function () {
                var validNumber = new RegExp(/^[0-9]+([,.][0-9]+)?$/);
                $scope.employeeErrors = {
                    location: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Location is required.') },
                    classCode: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Class Code is required.') },
                    moreSuffix: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Class Code contains more than one suffix. Please select the appropriate Class Code and Suffix.') },
                    totalMontanaWages: { status: false, message: $filter('translate')('This is a required field') },
                    totalHours: { status: false, message: $filter('translate')('This is a required field') },
                    noOfEmployees: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Number of employees should be within the range of 0 to 2147483647 without decimal.') },
                    basis: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Please use only Estimated Wages for this class code within the range of 0 to 2147483647 without decimal.') },
                    perCapita: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Please use only Per Capita for this class code within the range of 0 to 2147483647 without decimal.') }
                };
                //check total montana wages error
                if ($scope.employee.totalMontanaWages != undefined || $scope.employee.totalMontanaWages != "") {
                    if ($scope.employee.totalMontanaWages !== '' || $scope.employee.totalMontanaWages !== null || $scope.employee.totalMontanaWages !== undefined) {
                        if (validNumber.test($scope.employee.totalMontanaWages) === false) {
                            $scope.employeeErrors.totalMontanaWages.status = true;
                            $scope.employeeErrors.totalMontanaWages.message = $filter('translate')('Entered Total Montana Wages value is Invalid.');
                            return;
                        } else if (validNumber.test($scope.employee.totalMontanaWages) === true) {
                            var wage = $scope.employee.totalMontanaWages.indexOf('.');
                            if (wage != -1) {
                                var split = $scope.employee.totalMontanaWages.split('.')[0];
                                if (split.length > 16) {
                                    $scope.employeeErrors.totalMontanaWages.status = true;
                                    $scope.employeeErrors.totalMontanaWages.message = $filter('translate')('Entered Total Montana Wages value is Invalid.');
                                    return;
                                }
                            } else {
                                if ($scope.employee.totalMontanaWages.length > 16) {
                                    $scope.employeeErrors.totalMontanaWages.status = true;
                                    $scope.employeeErrors.totalMontanaWages.message = $filter('translate')('Entered Total Montana Wages value is Invalid.');
                                    return;
                                }
                            }
                        }
                    }
                }
                //check total hours error
                if ($scope.employee.totalHours != undefined || $scope.employee.totalHours != "") {
                    if ($scope.employee.totalHours !== '' || $scope.employee.totalHours !== null || $scope.employee.totalHours !== undefined) {
                        if (validNumber.test($scope.employee.totalHours) === false) {
                            $scope.employeeErrors.totalHours.status = true;
                            $scope.employeeErrors.totalHours.message = $filter('translate')('Entered Total Hours value is Invalid.');
                            return;
                        } else if (validNumber.test($scope.employee.totalHours) === true) {
                            var wage = $scope.employee.totalHours.indexOf('.');
                            if (wage != -1) {
                                var split = $scope.employee.totalHours.split('.')[0];
                                if (split.length > 9) {
                                    $scope.employeeErrors.totalHours.status = true;
                                    $scope.employeeErrors.totalHours.message = $filter('translate')('Entered Total Hours value is Invalid.');
                                    return;
                                }
                            } else {
                                if ($scope.employee.totalHours.length > 9) {
                                    $scope.employeeErrors.totalHours.status = true;
                                    $scope.employeeErrors.totalHours.message = $filter('translate')('Entered Total Hours value is Invalid.');
                                    return;
                                }
                            }
                        }
                    }
                }
                if (!$scope.employee.value.location) {
                    $scope.employeeErrors.location.status = true;
                } else if (!$scope.employee.value.classCode) {
                    $scope.employeeErrors.classCode.status = true;
                } else if ($scope.employee.totalMontanaWages == undefined) {
                    $scope.employeeErrors.totalMontanaWages.status = true;
                } else if ($scope.employee.totalHours == undefined) {
                    $scope.employeeErrors.totalHours.status = true;
                } else {
                    /*
                    //let perCapitaClassCodes = ['0908','0913'];
                     		//setting up percapita is mandatory based on selected class code
                     		if($scope.perCapitaClasses  && $scope.perCapitaClasses.indexOf($scope.employee.value.classCode.code) != -1){
                     			if($scope.employee.perCapita.value === '' || validNumber.test($scope.employee.perCapita.value) === false || $scope.employee.perCapita.value % 1 !== 0 || $scope.employee.perCapita.value < 0 ||  $scope.employee.perCapita.value > 2147483647){
                     				$scope.employeeErrors.perCapita.status = true;
                     			    $scope.employeeErrors.perCapita.message = 'Please use only Per Capita for the class code '+$scope.employee.value.classCode.code+' within the range of 0 to 2147483647 without decimal.';
                     			}
                     			if($scope.employee.totalHours !=='' && $scope.employee.totalHours !== null && $scope.employee.totalHours !== undefined && $scope.employeeErrors.perCapita.status === false){
                     				$scope.employeeErrors.basis.status = true;
                     			    $scope.employeeErrors.basis.message ='Please use only Per Capita for the class code '+$scope.employee.value.classCode.code+' within the range of 0 to 2147483647 without decimal.';
                     			}
                     			}
                     		else{
                     			
                     		}*/
                }
            };
            /**
              * Function to check employee error status
              * @param {None} - checks values from $scope.employeeErrors.
              * @returns {None} - sets $scope.displayEmployeeError.
              * @private
              */
            $scope.checkEmployeeErrors = function () {
                $scope.displayEmployeeError = false;
                angular.forEach($scope.employeeErrors, function (error) {
                    if (error.status === true) {
                        $scope.displayEmployeeError = true;
                        return;
                    }
                });
                return $scope.displayEmployeeError;
            };
            //save in portal
            /**
              * Function executed when save button is clicked. If no employee Errors exist, populate the values of totalMontanaWages, totalHOurs based on user entry.
              * @param {String, object, int, int} - type, employee, selected index, id
              * @returns {boolean} - If $scope.errors is false the function returns false, otherwise, populates required $scope variables with values.
              * @private
              */
            $scope.onSave = function (type, employee, index, id) {
                console.log("id---->" + id);
                $scope.selectedEntry = index; //console.log("-->"+row.totalMontanaWages+"---"+row.totalHours)
                $scope.employee = {};
                $scope.employee.totalMontanaWages = employee.totalMontanaWages; //row.totalMontanaWages;
                $scope.employee.totalHours = employee.totalHours;
                $scope.finalDataValidation = false;
                var validNumber = new RegExp(/^[0-9]+([,.][0-9]+)?$/);
                $scope.wagesError = false;
                $scope.hoursError = false;
                //$scope.updateEmployeeErrors();
                var keepGoingSave = true;

                //check total montana wages error
                if (employee.totalMontanaWages != undefined && employee.totalMontanaWages != "") {
                    if (employee.totalMontanaWages !== '' || employee.totalMontanaWages !== null || employee.totalMontanaWages !== undefined) {
                        if (validNumber.test(employee.totalMontanaWages) === false) {
                            $scope.wagesError = true;
                            $scope.errorMessage = $filter('translate')('Entered Total Montana Wages value is Invalid.');
                            $scope.finalDataValidation = true;
                        } else if (validNumber.test(employee.totalMontanaWages) === true) {
                            var wage = employee.totalMontanaWages.indexOf('.');
                            if (wage != -1) {
                                var split = employee.totalMontanaWages.split('.')[0];
                                if (split.length > 16) {
                                    $scope.wagesError = true;
                                    $scope.errorMessage = $filter('translate')('Entered Total Montana Wages value is Invalid.');
                                    $scope.finalDataValidation = true;
                                } else {
                                    $scope.finalDataValidation = false;
                                }
                            } else {
                                if (employee.totalMontanaWages.length > 16) {
                                    $scope.wagesError = true;
                                    $scope.errorMessage = $filter('translate')('Entered Total Montana Wages value is Invalid.');
                                    $scope.finalDataValidation = true;
                                } else {
                                    $scope.finalDataValidation = false;
                                }
                            }
                        }
                    }
                }
                //check total hours error
                if (employee.totalHours != undefined && employee.totalHours != "") {
                    if (employee.totalHours !== '' || employee.totalHours !== null || employee.totalHours !== undefined) {
                        if (validNumber.test(employee.totalHours) === false) {
                            $scope.hoursError = true;
                            $scope.errorMessage = $filter('translate')('Entered Total Hours value is Invalid.');
                            $scope.finalDataValidation = true;
                        } else if (validNumber.test(employee.totalHours) === true) {
                            var wage = employee.totalHours.indexOf('.');
                            if (wage != -1) {
                                var split = employee.totalHours.split('.')[0];
                                if (split.length > 9) {
                                    $scope.hoursError = true;
                                    $scope.errorMessage = $filter('translate')('Entered Total Hours value is Invalid.');
                                    $scope.finalDataValidation = true;
                                } else {
                                    $scope.finalDataValidation = false;
                                }
                            } else {
                                if (employee.totalHours.length > 9) {
                                    $scope.hoursError = true;
                                    $scope.errorMessage = $filter('translate')('Entered Total Hours value is Invalid.');
                                    $scope.finalDataValidation = true;
                                } else {
                                    $scope.finalDataValidation = false;
                                }
                            }
                        }
                    }
                }
                angular.forEach($scope.periodData.constructionCreditList, function (cons) {
                    if (keepGoingSave) {
                        if (cons.totalMontanaWages == undefined || cons.totalHours == undefined || cons.totalHours == '' || cons.totalMontanaWages == '') {
                            $scope.finalDataValidation = true;
                            keepGoingSave = false;
                        } else {
                            $scope.finalDataValidation = false;
                        }
                    }
                });
            };
            /**
                * Function that keeps track of keys entered by user - keyCode 46 is for delete button...
                * ensures only necessary function keys are registered for events.
                * @param {Object, Object} event, field
                * @returns {boolean}
                * @private
                */
            $scope.restrictAlphabets = function (event, field) {
                if (event.keyCode == 46) {
                    if (event.value && event.value.indexOf('.') >= 0) {
                        if (event.value && event.value.length >= 2) {
                            return false;
                        }
                        return true;
                    } else if (event.value && event.value.indexOf('..') >= 0) {
                        return false;
                    } else {
                        return false;
                    }
                } else if (event.keyCode < 48 || event.keyCode > 57) {
                    event.preventDefault();
                }
            };
            $scope.onRemove = function (index) {
                if (index !== 'new' && $scope.portalCoveredEmployees) $scope.portalCoveredEmployees.splice(index, 1);
                $scope.isAddingNew = false;
                $scope.isEditing = false;
                $scope.resetErrors();
            };
            /**
               * Function executed to submit values for submitting Construction credit application. Once added an activity is created and user
               * is routed to the policy details screen. If an error occurs during the process user is presented with an error view.
               * @param {None} uses values from $scope object.
               * @returns {Object} - set amount and currency values for the Vm object
               * @private
               */
            $scope.onSubmit = function () {
                $scope.disableSubmit = true;
                /**  Get Construction Credit Data for the given policy change job no **/
                PolicyService.updateConstructionCreditWages($scope.jobNumber, $scope.periodData.constructionCreditList).then(function (data) {
                    $scope.disableSubmit = false;
                    $rootScope.CCAdded = 'CCAdded';
                    /**  Creates activity after successful creation and update of construction credit application  **/
                    PolicyService.createActivityForCCApplication($scope.jobNumber);
                    //route to the policy details page to show the confirmation message.
                    $state.go('policies.detail.summary', {
                        'policyNumber': $stateParams.policyNumber
                    });
                }, function (res) {
                    $scope.disableSubmit = false;
                    ModalService.showError('Error while submitting Construction Credit Application', 'Please try again later.');
                });
            };
            /**
             * Function executed when user elects to withdraw the Construction Credit application. withdrawPolicyTransaction method withdraws the transaction
             * and user is redirected to the policy detail screen.
             * @param {None} uses values from $scope object.
             * @returns {none}
             * @private
             */
            $scope.withdraw = function () {
                var withdrawModal = ModalService.showConfirm('Confirmation', 'Do you wish to withdraw this transaction?', '', 'Withdraw', '', 'Cancel').result;
                withdrawModal.then(function (res) {
                    var withdrawPromise = PolicyService.withdrawPolicyTransaction($stateParams.policyNumber, $scope.jobNumber);
                    withdrawPromise.then(function (res) {
                        $state.go('policies.detail.summary', {
                            'policyNumber': $stateParams.policyNumber
                        });
                    });
                });
            };

            /*rounding to two decimal  */
            function roundToTwo(num) {
                return +(Math.round(num + "e+2") + "e-2");
            }
        }]

    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/CCEWDirective/CCEW.js
// module id = 1729
// module chunks = 0